import Monster from './Monster'

export default class Player extends Monster {
  constructor(value: number) {
    super('You', value)
  }

  clone() {
    return new Player(this.value)
  }
}
